<template>

</template>

<script>
export default {
    name: "Tag"
}
</script>

<style scoped>

</style>